import { render } from "./index.vue?vue&type=template&id=988f9eea&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=988f9eea&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=988f9eea&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988f9eea"]])

export default __exports__